module.exports = __webpack_public_path__ + "img/christmas-house-2.bd27b9c9.svg";